const namespace = 'Passengers';

export const FETCH_TICKETS = `${namespace}/FETCH_TICKETS`;
export const FETCH_TICKETS_FAILURE = `${namespace}/FETCH_TICKETS_FAILURE`;
export const FETCH_TICKETS_SUCCESS = `${namespace}/FETCH_TICKETS_SUCCESS`;

export const SET_PASSENGERS_COUNTS = `${namespace}/SET_PASSENGERS_COUNTS`;
export const SET_TICKETS_INFO = `${namespace}/SET_TICKETS_INFO`;




// WEBPACK FOOTER //
// ./src/containers/Passengers/constants.js